import { render, staticRenderFns } from "./RechtlicheHinweise.vue?vue&type=template&id=0b8c7cb4&scoped=true&"
import script from "./RechtlicheHinweise.vue?vue&type=script&lang=js&"
export * from "./RechtlicheHinweise.vue?vue&type=script&lang=js&"
import style0 from "./RechtlicheHinweise.vue?vue&type=style&index=0&id=0b8c7cb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8c7cb4",
  null
  
)

export default component.exports